<script lang="ts">
  import type { schema } from "@editor/schema";
  import Block from "./Block.svelte";
  import { isEditor } from "./utils";
  import LinkContent from "./utils/LinkContent.svelte";

  export let block: schema.EmbedIframeBlock;

  // Sine the google form url will be opened in new tab, or at least not in IFRAME,
  // We should remove the `embedded` flag
  const cta = block.iframe_url ? { url: block.iframe_url.replace(/embedded=true/gi, ""), id: `iframe-${block._id}` } : undefined;
</script>

<Block {block} on:click on:delete on:duplicate let:isEmpty showEmpty layouts={["-"]} size="full">
  {#if isEmpty}
    <div class="w-full text-center">
      empty form
      {#if block._defaults && block._defaults.iframe_url}
        <iframe class="rounded" aria-label="External Form" src={block._defaults.iframe_url} title="External Form" width="100%" height="400"
        ></iframe>
      {/if}
    </div>
  {:else}
    <div class="no-screenshot group relative flex w-full flex-col text-center">
      <iframe
        class="rounded"
        aria-label="External Form"
        class:pointer-events-none={isEditor()}
        src={block.iframe_url}
        title="External Form"
        width="100%"
        height="400"></iframe>
      {#if !isEditor()}
        <LinkContent
          {cta}
          type="form-emb"
          linkText={block.iframe_url}
          class="material-icons notranslate absolute bottom-1 right-10 flex items-center rounded bg-nxgray-700 bg-opacity-80 p-1 text-18 text-2xl leading-none text-white opacity-40 shadow-md group-hover:opacity-100">
          open_in_new
        </LinkContent>
      {/if}
    </div>

    {#if !isEditor()}
      <!-- Screenshot only version -->
      <div class="only-screenshot w-full text-center">
        <iframe
          class="rounded"
          aria-label="External Form"
          src={block.iframe_url}
          title="External Form"
          width="100%"
          height="400"
          scrolling="no"></iframe>
      </div>
    {/if}
  {/if}
</Block>
